import { useState } from "react";
import CustomInputNumber from "./CustomInputNumber";

function CustomInputNumberV2({
  name = "",
  placeholder,
  value = "",
  setValue,
  onPressEnter = () => {},
  shouldSetValueSetObj = false,
  inputClasses = "",
  isDecimalAllowed = false,
  disabled = false,
  highlight = false,
  max = 9999999999,
  min = -9999999999,
  addonBefore = "",
  addonAfter = "",
}) {
  const [focused, setFocused] = useState(false);

  return (
    <div
      className={`flex w-full h-[32px] overflow-hidden border transition-colors 
        rounded-md
        ${focused ? "border-blue-500 shadow-[0_0_0_2px_rgba(24,144,255,0.2)]" : "border-gray-300"}
      `}
    >
      {addonBefore && (
        <span
          className={`
            flex-shrink-0 flex items-center px-3 bg-gray-100 text-sm text-gray-700 border-r border-gray-300
            ${!addonAfter ? "rounded-r-none" : ""}
            rounded-l-md
          `}
        >
          {addonBefore}
        </span>
      )}

      <CustomInputNumber
        name={name}
        placeholder={placeholder}
        value={value}
        setValue={setValue}
        onPressEnter={onPressEnter}
        shouldSetValueSetObj={shouldSetValueSetObj}
        inputClasses={`!border-0 !outline-none !ring-0 !rounded-none w-full h-full px-2 ${inputClasses}`}
        isDecimalAllowed={isDecimalAllowed}
        disabled={disabled}
        min={min}
        max={max}
        highlight={highlight}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />

      {addonAfter && (
        <span
          className={`
           flex-shrink-0 flex items-center px-3 bg-gray-100 text-sm text-gray-700 border-l border-gray-300
            rounded-r-md
          `}
        >
          {addonAfter}
        </span>
      )}
    </div>
  );
}

export default CustomInputNumberV2;
